import { IntentType } from '@40seas/entities/intents';
import { z } from 'zod';

export class QueryPaymentOptionsDto {
    intentType?: IntentType;
    buyerId?: string;
    invoiceId?: string;
    amount?: number;
}

export const QueryPaymentOptionsDtoSchema = z
    .object({
        buyerId: z.string().optional(),
        invoiceId: z.string().optional(),
        amount: z.number().optional(),
    })
    .strict();
